// Configuración centralizada de contacto de 3claus
export const WHATSAPP_NUMBER = '34610683948';
export const PHONE_NUMBER = '+34610683948';
export const PHONE_DISPLAY = '610 68 39 48';
export const CONTACT_EMAIL = 'hi@3claus.com';

/**
 * Genera un enlace de WhatsApp con mensaje predefinido.
 * @param {string} message - Mensaje contextual (traducido por página)
 * @returns {string} URL de WhatsApp
 */
export const whatsappLink = (message = '') => {
    return message
        ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
        : `https://wa.me/${WHATSAPP_NUMBER}`;
};

/**
 * Envía un lead al mail.php del hosting.
 * @param {Object} options
 * @param {string} options.subject - Asunto del correo
 * @param {Object} options.fields - Campos del formulario (Name, Phone, Email, ...)
 * @param {string} [options.projectName] - Remitente mostrado (por defecto "3claus")
 * @returns {Promise<Object>} Respuesta JSON del servidor
 */
export const submitLead = async ({ subject, fields = {}, projectName = '3claus' }) => {
    const payload = new URLSearchParams();
    payload.append('project_name', projectName);
    payload.append('admin_email', CONTACT_EMAIL);
    payload.append('form_subject', subject);

    Object.entries(fields).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value).trim() !== '') {
            payload.append(key, String(value));
        }
    });

    const res = await fetch('/mail.php', {
        method: 'POST',
        body: payload
    });

    if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
    }

    return res.json().catch(() => ({}));
};
